import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    filters: {
        "search": "",
        "sort": {
            "attributes": ["created_date"],
            "sorts": ["desc"]
        },
        "filters": [
        ],
        "pageNo": 1,
        "itemsPerPage": 10
    },
};

const knowledgePartnerSlice = createSlice({
    name: 'knowledgePartner',
    initialState,
    reducers: {
        updateFilter: (state, action) => {
            state.filters = action.payload;
        },
        updateReducer: (state, action) => {
            state.filters = action.payload;
        },
    },
});

export const {
    updateFilter,
    updateReducer,
} = knowledgePartnerSlice.actions;

export default knowledgePartnerSlice.reducer;
